import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id F5F53184-51BB-46A3-AB67-D799A1D15F7F
 * name alpha-c
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaCIcon = createSvgIcon(<><path d="M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V14H13V15H11V9H13V10H15V9A2,2 0 0,0 13,7H11Z" /></>, 'AlphaCIcon');
export default AlphaCIcon